module.exports = __webpack_public_path__ + "img/ozdg.9ecc53e7.png";